import { Link } from "react-router-dom";

export const PrivacyPolicy = () => {
  return (
    <main className="pt-20">
      {/* Hero Banner */}
      <div className="bg-brand-navy py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
          <span className="inline-block text-xs sm:text-sm font-medium uppercase tracking-widest text-brand-orange mb-2">
            Legal
          </span>
          <h1 className="font-heading text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight uppercase text-white">
            Privacy Policy
          </h1>
          <p className="font-body text-base sm:text-lg text-white/70 mt-3 max-w-2xl">
            Last updated: February 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-12">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Introduction
            </h2>
            <p className="text-brand-slate mb-6">
              Roll Orlando ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website rollorlando.com or use our painting services in Orlando, Florida and surrounding areas.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Information We Collect
            </h2>
            <p className="text-brand-slate mb-4">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li><strong>Personal Information:</strong> Name, email address, phone number, mailing address, and other contact details you provide when requesting a quote or contacting us.</li>
              <li><strong>Project Information:</strong> Details about your painting project, property information, photos, and service preferences.</li>
              <li><strong>Communication Data:</strong> Records of your communications with us, including emails, phone calls, and messages.</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our website, including IP address, browser type, pages visited, and time spent on pages.</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              How We Use Your Information
            </h2>
            <p className="text-brand-slate mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>Provide estimates and quotes for painting services</li>
              <li>Schedule and perform painting work at your property</li>
              <li>Communicate with you about your project and our services</li>
              <li>Send promotional offers, newsletters, and updates (with your consent)</li>
              <li>Improve our website and customer service</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Information Sharing
            </h2>
            <p className="text-brand-slate mb-6">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our business (such as payment processors or scheduling software), but only to the extent necessary to provide our services to you.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Data Security
            </h2>
            <p className="text-brand-slate mb-6">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Your Rights
            </h2>
            <p className="text-brand-slate mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-brand-slate space-y-2 mb-6">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications at any time</li>
              <li>Withdraw consent where processing is based on consent</li>
            </ul>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Cookies
            </h2>
            <p className="text-brand-slate mb-6">
              Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can set your browser to refuse cookies, but this may limit some features of our website.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Children's Privacy
            </h2>
            <p className="text-brand-slate mb-6">
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Changes to This Policy
            </h2>
            <p className="text-brand-slate mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="font-heading text-2xl font-bold text-brand-navy uppercase mt-8 mb-4">
              Contact Us
            </h2>
            <p className="text-brand-slate mb-4">
              If you have any questions about this Privacy Policy or our privacy practices, please contact us:
            </p>
            <div className="bg-brand-ice p-6 rounded-sm border border-border mb-8">
              <p className="text-brand-navy font-semibold mb-2">Roll Orlando</p>
              <p className="text-brand-slate">Orlando, Florida</p>
              <p className="text-brand-slate">Phone: <a href="tel:+14079494656" className="text-brand-orange hover:underline">(407) 949-4656</a></p>
              <p className="text-brand-slate">Email: <a href="mailto:sales@rollorlando.com" className="text-brand-orange hover:underline">sales@rollorlando.com</a></p>
              <p className="text-brand-slate">Website: <a href="https://rollorlando.com" className="text-brand-orange hover:underline">rollorlando.com</a></p>
            </div>

            <div className="mt-8 pt-8 border-t border-border">
              <Link 
                to="/" 
                className="text-brand-orange hover:text-brand-navy font-medium transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
